import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import sv from 'i18n-iso-countries/langs/sv.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(sv)
countries.registerLocale(de)

const DEFAULT_LOCALE = 'en'

const allowedLocales = ['en', 'sv', 'de']

export function getNamesWithFallback(locale: string) {
    return countries.getNames(allowedLocales.includes(locale) ? locale : DEFAULT_LOCALE)
}
export default countries
